import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=3d2fd1f8&scoped=true"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"
import style0 from "./Roles.vue?vue&type=style&index=0&id=3d2fd1f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2fd1f8",
  null
  
)

export default component.exports